import {
  MODE_OF_TRANSPORT_EXPRESS_ROAD,
} from 'shared/ncts/common/constants'
import { RuleResult } from '../../../../types/DeclarationP5'

const C0544Validator = {
  validateHouseConsignmentConsignorRequirement: ({
    security,
    specificCircumstanceIndicator,
    reducedDatasetIndicator,
    isConsignmentConsignorPresent,
  }: {
    security: string
    specificCircumstanceIndicator?:string
    reducedDatasetIndicator?:string
    isConsignmentConsignorPresent?:boolean
  }): RuleResult => {
    if (['1', '3'].includes(security)) {
      return specificCircumstanceIndicator === MODE_OF_TRANSPORT_EXPRESS_ROAD
        ? 'REQUIRED'
        : 'NOT_ALLOWED'
    }

    if (security === '0' && reducedDatasetIndicator === 'true') {
      return 'NOT_ALLOWED'
    }

    return isConsignmentConsignorPresent ? 'NOT_ALLOWED' : 'OPTIONAL'
  },
}

export default C0544Validator
